import script from "./TrashIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TrashIcon.vue?vue&type=script&setup=true&lang=js"

export default script